/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_Requested_OwnInputs */

const en_vendor_return_status_requested_own = /** @type {(inputs: Vendor_Return_Status_Requested_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To confirm`)
};

/**
* | output |
* | --- |
* | "To confirm" |
*
* @param {Vendor_Return_Status_Requested_OwnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_requested_own = /** @type {((inputs?: Vendor_Return_Status_Requested_OwnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_Requested_OwnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_requested_own(inputs)
});